// @flow
import { useContext, useEffect } from "react";
import { ThemeContext } from "styled-components";

export const useDesktopFocus = (
  ref: { current: React.ElementRef<any> | null },
  skipFocus: boolean = false,
) => {
  const theme = useContext(ThemeContext);
  useEffect(() => {
    if (
      !skipFocus &&
      window.innerWidth >= theme.breakpoints.desktop &&
      ref.current
    ) {
      ref.current.focus();
    }
  }, []);
};
